module.exports = __webpack_public_path__ + "static/media/logo_black.7b7963b5.png";